<template>
  <div>
    <div class="Index" v-show="indexStatus">
      <div class="bg">
        <div class="login" @click="loginFunc">
          <p class="loginEnd" v-if="loginStatus">
            会员
            <br />
            {{ vipAccount }}
          </p>
          <p class="loginStart" v-else>点击登录</p>
        </div>
      </div>

      <div class="content">
        <selfServe
          ref="selfServe"
          :vipAccount="vipAccount"
          :serviceUrl="serviceUrl"
          @login="loginFunc()"
          @loginSuccess="loginSuccess()"
          @loginFail="loginFail()"
        ></selfServe>
      </div>
    </div>

    <!-- 客服按钮 -->
    <div class="service" @click="serviceFunc">
      <img class="serviceBg" src="../assets/service.gif" alt />
      <img class="serviceMask" src="../assets/serviceMask.png" alt />
    </div>

    <!-- 一键领取按钮 -->
    <div class="allget" @click="toAllGet">
      <img class="allgetBg" src="../assets/allget.gif" alt />
      <img class="allGetMask" src="../assets/allGetMask.png" alt />
      <img class="ball" src="../assets/ball.png" alt />
    </div>

    <!-- 登录弹窗 -->
    <div class="loginAlert" v-show="loginAlert">
      <div class="loginAlertTips">
        <img src="../assets/login.png" alt />
        <div class="themeInput">
          <input type="text" v-model="vipAccount" placeholder="请输入会员账号" />
        </div>
        <div class="loginAlertYes" @click="openLogin"></div>
        <div class="loginAlertClose" @click="closeLogin"></div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="mask" v-if="false"></div>
  </div>
</template>

<script>
import { getConfig } from "@/api/index";
import selfServe from "../components/selfServe.vue";
import { Message, Loading } from "element-ui";

export default {
  name: "turn-table",
  components: {
    selfServe
  },
  props: {
    msg: String
  },
  data() {
    return {
      noticePlay: true,
      indexStatus: true,
      recordStatus: false,
      serviceStatus: true,
      serviceUrl: "",
      redUrl: "",
      turntableUrl: "",
      act_id: "",
      actList: [],
      autoplay: true,
      loginStatus: false,
      loginAlert: false,
      vipAccount: "",
      loginLoading: false
    };
  },
  methods: {
    // 登录
    loginFunc() {
      this.loginAlert = true;
    },
    openLogin() {
      if (!this.vipAccount) {
        Message({
          message: "请输入账号！",
          type: "warning",
          duration: 5 * 1000
        });
      } else {
        this.loginLoading = Loading.service({
          fullscreen: true,
          background: "rgba(255, 255, 255, 0.3)"
        });

        this.$refs.selfServe.getSelfData();
      }
    },
    closeLogin() {
      this.loginAlert = false;
    },
    // 登录成功
    loginSuccess() {
      this.loginStatus = true;

      this.loginAlert = false;
      setTimeout(() => {
        this.loginLoading.close();
      }, 500);
    },
    // 登录失败
    loginFail() {
      this.loginAlert = false;
      setTimeout(() => {
        this.loginLoading.close();
      }, 500);
    },

    // 跳转客服
    serviceFunc() {
      window.location.href = this.serviceUrl;
    },
    // 一键领取
    toAllGet() {
      this.$refs.selfServe.AllGet();
    },
    // 跳转转盘
    toTurnTable() {
      window.location.href = this.turntableUrl;
    },
    // 跳转红包
    toRed() {
      window.location.href = this.redUrl;
    }
  },
  async mounted() {
    // 配置
    getConfig({ appid: process.env.VUE_APP_APPID }).then(res => {
      res.data.forEach(v => {
        if (v.key == "customer_service_url") {
          this.serviceUrl = v.value;
        }

        if (v.key == "zp_url") {
          this.turntableUrl = v.value;
        }

        if (v.key == "packet_url") {
          this.redUrl = v.value;
        }
      });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.Index {
  position: relative;
}
.content {
  background: url(../assets/bg_content.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 902px;
}

.bg {
  background: url("../assets/bg.jpg") no-repeat;
  background-size: 100%;
  width: 540px;
  height: 1562px;
  position: relative;
  .lookDetails {
    position: absolute;
    bottom: 55px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 218px;
    cursor: pointer;
  }
  .login {
    background: url("../assets/loginBtn.png") no-repeat;
    background-size: 100% 100%;
    width: 253px;
    height: 166px;
    position: absolute;
    top: 712px;
    left: 50%;
    transform: translate(-50%, 0);
    text-align: center;

    .loginStart {
      color: #fff;
      line-height: 110px;
      font-size: 37px;
    }
    .loginEnd {
      color: #fff;
      font-size: 22px;
      margin-top: 26px;
      line-height: 27px;
    }
  }
}

.playGameNum {
  height: 57px;
  width: 506px;
  line-height: 57px;
  color: #fff;
  font-size: 20px;
  margin: 0 auto;
  background: url("../assets/count_bg.png") no-repeat;
  position: absolute;
  top: 286px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 4;
}

.tickArea {
  position: absolute;
  left: 158px;
  bottom: 68px;
  z-index: 8;
  width: 100px;
  height: 22px;
  .tick {
    width: 17px;
    position: absolute;
    right: 11px;
    bottom: 1px;
  }
}

.toUp {
  margin-top: -40px; //向上移
  transition: all 0.5s;
}

.pb50 {
  padding-bottom: 50px;
}

.carousel {
  border: 1px solid #ff4b8c;
  border-radius: 15px;
  height: 190px;
  overflow: hidden;
  .carouselImg {
    position: relative;
    height: 190px;
    img {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.carousel /deep/ .el-carousel__indicators {
  left: inherit;
  right: 0;
}

.carousel /deep/ .el-carousel__item {
  border-radius: 10px;
}

.carousel /deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}
.carousel
  /deep/
  .el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  width: 6px;
  height: 6px;
  background: #fe50a5;
  border-radius: 50%;
  opacity: 1;
}

.hot {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, 222px);
  justify-content: space-between;
  .hotLi {
    width: 222px;
    height: 222px;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      border-radius: 15px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.TV {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 150px);
  justify-content: space-between;
  .TVLi {
    width: 150px;
    height: 150px;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      border-radius: 15px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.apply {
  position: fixed;
  right: 0;
  top: 358px;
  cursor: pointer;
  color: #fff;

  z-index: 5;
  .applyC {
    height: 42px;
    width: 109px;
    position: relative;
    margin-bottom: 15px;
    p {
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 109px;
      font-size: 16px;
      text-align: center;
    }
    img {
      width: 100%;
    }
  }
}

.apply_2 {
  position: fixed;
  right: 0;
  top: 443px;
  cursor: pointer;
  color: #fff;
  height: 42px;
  width: 109px;
  z-index: 5;
  img {
    width: 100%;
  }
}

.service {
  position: absolute;
  left: 0;
  top: 673px;
  cursor: pointer;
  color: #fff;
  z-index: 5;
  .serviceBg {
    width: 130px;
    position: relative;
    z-index: 1;
  }
  .serviceMask {
    width: 120px;
    position: absolute;
    bottom: 0;
    left: 0;
    position: absolute;
    bottom: -42px;
    left: 0;
  }
}

.allget {
  position: absolute;
  right: 0;
  top: 699px;
  cursor: pointer;
  color: #fff;
  z-index: 5;
  .allgetBg {
    width: 130px;
    position: relative;
    z-index: 1;
  }
  .allGetMask {
    width: 128px;
    position: absolute;
    bottom: -42px;
    left: 18px;
  }
  .ball {
    width: 101px;
    position: absolute;
    bottom: 29px;
    left: 16px;
  }
}

.loginAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .loginAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 400px;
    }
    .loginAlertYes {
      position: absolute;
      left: 37px;
      bottom: 56px;
      width: 327px;
      height: 65px;
      cursor: pointer;
      border-radius: 12px;
    }
    .loginAlertClose {
      position: absolute;
      right: 11px;
      top: 12px;
      width: 46px;
      height: 46px;
      cursor: pointer;
      border-radius: 12px;
    }
  }

  .themeInput {
    position: absolute;
    top: 276px;
    left: 50%;
    width: 263px;
    height: 68px;
    transform: translate(-50%, 0);
    text-align: center;
    input {
      background: none;
      border: 0;
      color: #5d52cc;
      font-size: 25px;
      width: 220px;
      margin-top: 20px;
      text-align: center;
      &::placeholder {
        color: #333;
        font-size: 20px;
      }
    }
    input[type="text"]:focus {
      outline: none;
    }
  }
}
</style>
